import { readingDateDisableCondition } from "@src/helpers/constants";
import {
  AppDispatch,
  dynamicSet,
  getAdditionalReportListClear,
  getAdditionalReportListRequest,
  getReadingList,
  Reading,
  useDynamicSelector,
} from "@src/redux";
import { DatePicker, Form, Modal, Popover } from "antd";
import dayjs, { Dayjs } from "dayjs";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaFileAlt } from "react-icons/fa";
import { FcCalendar } from "react-icons/fc";
import { MdLocationOn, MdOutlinePictureAsPdf } from "react-icons/md";
import {
  TbPlayerSkipBackFilled,
  TbPlayerSkipForwardFilled,
} from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import HealthScreeningReportModal from "../../home/readings/HealthScreeningReportModal";
import AdditionalReports from "./AdditionalReports";
import localizedFormat from "dayjs/plugin/localizedFormat";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import { from } from "@apollo/client";
import { getUuid } from "@src/helpers/functions";

dayjs.extend(localizedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
type Props = {};

const DetailsHeaderSecondRow = (props: Props) => {
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [currentTime, setCurrentTime] = useState(String);
  const [reading, setReading] = useState<Reading>({});
  // const [reading_index, set_reading_index] = useState<number>(0);
  const { result: readingList } = useSelector(getReadingList);
  const [openReportModal, setReportModal] = useState<boolean>(false);
  const [attachmentModal, setAttachmentModal] = useState<boolean>(false);
  const { reading: getReading } = useDynamicSelector("get_reading_details");
  const { readingIndex = 0 } = useDynamicSelector("get_reading_index");
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const [form] = Form.useForm();


  const handleDateChange = (date: any) => {
    let findDate = readingList?.items?.find(
      (read) =>
        moment(read.datetime).format("DD/MM/YYYY") ===
        moment(new Date(date)).format("DD/MM/YYYY")
    );
    let findIndex = readingList?.items?.findIndex(
      (read) =>
        moment(read.datetime).format("DD/MM/YYYY") ===
        moment(new Date(date)).format("DD/MM/YYYY")
    );

    // set_reading_index(find_index || 0);
    if (findDate?.datetime) {
      setSelectedDate(findDate?.datetime);
    }
    setCurrentTime(moment(findDate?.datetime).format("hh:mm A"));
    setReading(findDate || {});
    dispatch(
      dynamicSet("get_reading_details", {
        reading: findDate,
      })
    );
    setVisible(false);
  };

  const filterDate =
    readingList?.items
      ?.map((list) =>
        list?.datetime ? dayjs(list.datetime).format("YYYY-MM-DD") : undefined
      )
      .filter((date): date is string => date !== undefined) || [];
  const handleReport = () => {
    setReportModal(true);
  };
  const onCancel = () => {
    setReportModal(false);
    dispatch(getAdditionalReportListClear());
  };

  // useEffect(() => {
  //   if (
  //     !reading_index &&
  //     reading_list?.items &&
  //     reading_list?.items?.length > 0
  //   ) {
  //     let find_total = reading_list?.items.length - 1;
  //     // set_reading_index(find_total);
  //     dispatch(
  //       dynamicSet("get_reading_index", {
  //         reading_index: find_total,
  //       })
  //     );

  //     dispatch(
  //       dynamicSet("get_reading_details", {
  //         reading: reading_list?.items?.[find_total],
  //       })
  //     );
  //   } else {
  //     dispatch(
  //       dynamicSet("get_reading_details", {
  //         reading: null,
  //       })
  //     );
  //   }
  // }, [reading_list]);

  useEffect(() => {
    if (readingList?.items && readingList.items.length > 0) {
      const firstReading = readingList.items[0];
      setSelectedDate(dayjs(firstReading.datetime).toDate());
      setCurrentTime(moment(firstReading.datetime).format("hh:mm A"));
      setReading(firstReading);

      dispatch(
        dynamicSet("get_reading_index", {
          readingIndex: 0,
        })
      );

      dispatch(
        dynamicSet("get_reading_details", {
          reading: firstReading,
        })
      );
    }
  }, [readingList]);


  useEffect(() => {
    if (getReading?.id) {
      setSelectedDate(getReading?.datetime || null);
      setCurrentTime(moment(getReading?.datetime).format("hh:mm A"));
      setReading(getReading);
    }
  }, [getReading]);

  const handleForward = () => {
    if (readingList?.items && readingList?.items?.length > 0) {
      setSelectedDate(
        readingList?.items?.[readingIndex + 1]?.datetime || null
      );
      setCurrentTime(
        moment(readingList?.items?.[readingIndex + 1]?.datetime).format(
          "hh:mm A"
        )
      );
      setReading(readingList?.items?.[readingIndex + 1]);
      dispatch(
        dynamicSet("get_reading_index", {
          readingIndex: readingIndex + 1,
        })
      );
      dispatch(
        dynamicSet("get_reading_details", {
          reading: readingList?.items?.[readingIndex + 1],
        })
      );
      // set_reading_index(reading_index + 1);
    }
  };
  const handleBackForward = () => {
    if (
      readingList?.items &&
      readingList.items.length > 0 &&
      readingIndex > 0
    ) {
      const prevReading = readingList.items[readingIndex - 1];

      setSelectedDate(prevReading?.datetime || null);
      setCurrentTime(moment(prevReading?.datetime).format("hh:mm A"));
      setReading(prevReading);

      dispatch(
        dynamicSet("get_reading_index", {
          readingIndex: readingIndex - 1,
        })
      );
      dispatch(
        dynamicSet("get_reading_details", {
          reading: prevReading,
        })
      );
    } else {
      console.warn("No previous reading available");
    }
  };
  const handleClick = () => {
    window.open(
      "http://maps.google.com?daddr=" +
        reading?.location?.latitude +
        "," +
        reading?.location?.longitude +
        "&amp;ll="
    );
  };


  return (
    <div className="details_second_row">
      <div className="details_last_screening_container">
        <span className="details_reading_date_text" id="reading_date_time">
          {t("reading_date_time")}
        </span>
      </div>
      <div className="details_screening_date_box">
        <div className="details_screening_icon_container">
          <TbPlayerSkipBackFilled
            className="date_forward_icon "
            onClick={
              readingIndex ===
              Number(
                (readingList?.items && readingList?.items?.length - 1) || 0
              )
                ? () => {}
                : handleForward
            }
            style={{
              cursor:
                readingIndex ===
                Number(
                  (readingList?.items && readingList?.items?.length - 1) || 0
                )
                  ? "not-allowed"
                  : "pointer",
              color:
                readingList?.items &&
                readingList?.items?.length - 1 === readingIndex
                  ? "#c9c9c9"
                  : "#727272",
            }}
          />
        </div>
        <div className="details_reading_date_container">
          <DatePicker
            onChange={handleDateChange}
            style={{ border: "none" }}
            suffixIcon={<FcCalendar />}
            value={selectedDate ? dayjs(selectedDate) : null}
            allowClear={false}
            format={"DD-MMM-YYYY"}
            disabledDate={(date: any) =>
              readingDateDisableCondition(date, filterDate)
            }
            id="screening_date_picker"
          />
        </div>
        <div className="details_reading_date_container">
          <span className="details_reading_screening_date">{currentTime}</span>
        </div>

        <div className="details_screening_icon_container">
          <TbPlayerSkipForwardFilled
            className="date_forward_icon"
            onClick={readingIndex !== 0 ? handleBackForward : () => {}}
            style={{
              cursor: readingIndex === 0 ? "not-allowed" : "pointer",
              color: readingIndex === 0 ? "#c9c9c9" : "#727272",
            }}
          />
        </div>
      </div>
      <div className="details_screening_date_box">
        <div className="details_doctor_viewed_container">
          <span className="details_reading_date_text" id="doctor_viewed">
            {t("doctor_viewed")}
          </span>
        </div>
        <div className="details_reading_date_container">
          <span className="details_reading_screening_date">
            {reading?.doctorViewedDatetime
              ? moment(reading?.doctorViewedDatetime).format("DD-MM-YYYY")
              : "-"}
          </span>
          <span className="details_reading_screening_date">
            {reading?.doctorViewedDatetime
              ? moment(reading?.doctorViewedDatetime).format("hh:mm A")
              : "-"}
          </span>
        </div>
      </div>
      <div className="details_location_icon_container">
        {/* <div className="details_screening_icon_container">
          <FaFileAlt
            className="date_location_icon"
            onClick={handle_attachments}
          />
        </div> */}
        <div className="details_screening_icon_container">
          <MdLocationOn
            className={
              !reading?.location?.latitude || !reading?.location?.longitude
                ? "location_disabled"
                : "date_location_icon"
            }
            onClick={reading?.location ? handleClick : undefined}
          />
        </div>

        <div className="details_screening_icon_container">
          <MdOutlinePictureAsPdf
            className={
              reading?.ecgReading?.ecgUrl || reading?.ecgReading?.pdfUrl
                ? "date_pdf_ecg_icon"
                : "date_pdf_icon"
            }
            onClick={handleReport}
          />
        </div>
      </div>{" "}
      <Modal
        title={t("additional_reports")}
        footer={null}
        open={attachmentModal}
        onCancel={onCancel}
      >
        <AdditionalReports onCancel={onCancel} form={form} />
      </Modal>
      <HealthScreeningReportModal
        visible={openReportModal}
        onCancel={onCancel}
        record={reading}
      />
    </div>
  );
};

export default DetailsHeaderSecondRow;
